import { render, staticRenderFns } from "./tag-list.vue?vue&type=template&id=50ececf2&scoped=true&"
import script from "./tag-list.vue?vue&type=script&lang=js&"
export * from "./tag-list.vue?vue&type=script&lang=js&"
import style0 from "./tag-list.vue?vue&type=style&index=0&id=50ececf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ececf2",
  null
  
)

export default component.exports